var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferencias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 1,
    y: 15.1667,
    width: 12.8333,
    height: 12.8333,
    rx: 2.33333,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 16.167,
    width: 12.8333,
    height: 12.8333,
    rx: 2.33333,
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    x: 16.167,
    y: 15.1667,
    width: 12.8333,
    height: 12.8333,
    rx: 2.33333,
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M1.91113 7.66462L5.79361 10.8191L13.0732 2.88086",
    stroke: "#EFF4F1",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencias);
export default __webpack_public_path__ + "static/media/preferencias.27c5a1b2c9e88f63c36a6d6381dedcd4.svg";
export { ForwardRef as ReactComponent };